import { Skeleton } from 'components/Skeleton/Skeleton'

import Styles from './LoadingSkeleton.module.scss'

export const LoadingSkeleton = () => {
  return (
    <div className={Styles.container}>
      <div className={Styles.leftPanel}>
        <Skeleton className={Styles.skeleton} active title={false} paragraph={{ rows: 3, width: '100%' }} />
        <Skeleton className={Styles.skeleton} active title={false} paragraph={{ rows: 1, width: '50%' }} />
      </div>
      <div className={Styles.rightPanel}>
        <div className={Styles.rightPanelHeader}>
          <Skeleton className={Styles.skeleton} active avatar={{ size: 'large' }} paragraph={{ rows: 1 }} />
        </div>
        <Skeleton className={Styles.skeleton} active title={false} paragraph={{ rows: 3, width: '100%' }} />
        <Skeleton className={Styles.skeleton} active title={false} paragraph={{ rows: 1, width: '50%' }} />
      </div>
    </div>
  )
}
